class ContactForm extends HTMLElement {
  constructor() {
    super();
    this.contactForm = this;
    this.subjectSelect = this.contactForm.querySelector(".js-choice-subject select");
    this.subjectOptions = this.subjectSelect ? this.subjectSelect.querySelectorAll("option") : [];
    this.categories = this.contactForm.querySelectorAll(".js-container-category");
    this.answers = this.contactForm.querySelectorAll(".js-answer");
    this.textarea = this.contactForm.querySelector(".js-answer-body");
    this.btns = this.contactForm.querySelectorAll(".js-contact-btn");
    this.inputSubject = this.contactForm.querySelector(".js-input-subject");
    this.inputCategory = this.contactForm.querySelector(".js-input-category");
  }
  connectedCallback() {
    this.subjectSelect.addEventListener("change", () => this.displayCategory());
    this.categories.forEach((category) => {
      const select = category.querySelector("select");
      select.addEventListener("change", () => {
        const option = select.querySelectorAll("option")[select.selectedIndex];
        this.inputCategory.value = option.value !== "other" ? option.value : "Autre demande";
        this.displayAnswer(option.value);
      });
    });
    this.btns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.hideAnswers();
        this.textarea.classList.remove("u-none");
      });
    });
    this.checkDevice();
  }
  checkDevice() {
    const ua = navigator.userAgent;
    let mobileDevice = false;
    if (/(tablet|ipad|playbook|silk)/i.test(ua)) {
      mobileDevice = true;
    } else if (/iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      mobileDevice = true;
    }
    if (mobileDevice) {
      const customSelectOptions = document.querySelectorAll(".custom-select-option");
      for (const customSelectOption of customSelectOptions) {
        customSelectOption.style.display = "none";
      }
      const customSelectContainers = document.querySelectorAll(".custom-select-container");
      for (const customSelectContainer of customSelectContainers) {
        customSelectContainer.style.background = "#fff";
        customSelectContainer.style.height = "40px";
      }
    }
  }
  displayCategory() {
    const option = this.subjectOptions[this.subjectSelect.selectedIndex];
    const subject = option.value;
    this.inputSubject.value = subject;
    this.hideAnswers();
    this.categories.forEach((category) => {
      if (category.dataset.subjectTarget === subject) {
        this.selectFirstOption(category);
        category.classList.remove("u-none");
        if (category.hasAttribute("data-subject-empty")) {
          this.textarea.classList.remove("u-none");
        }
      } else {
        category.classList.add("u-none");
      }
    });
  }
  selectFirstOption(category) {
    const select = category.querySelector("select");
    select.querySelectorAll("option")[0].selected = true;
    select.dispatchEvent(new CustomEvent("change"));
  }
  hideAnswers() {
    this.answers.forEach((answer) => answer.classList.add("u-none"));
  }
  displayAnswer(category) {
    this.hideAnswers();
    if (category === "other") {
      this.textarea.classList.remove("u-none");
    } else if (category !== "") {
      const answer = [...this.answers].find((a) => a.dataset.categoryTarget === category);
      if (answer) {
        answer.classList.remove("u-none");
      }
      if (answer && answer.dataset.textareaOpen === "true") {
        this.textarea.classList.remove("u-none");
        answer.querySelector(".contact-btn-container").classList.add("u-none");
      }
    }
  }
}
if (customElements.get("contact-form") === void 0) {
  customElements.define("contact-form", ContactForm);
}
